import React, { type FunctionComponent, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import AppHeader from 'legacy/components/AppHeader'
import { CallbackConfigurationFormContainer } from 'domains/connect/components/CallbackConfigurationForm'
import { useCallbackConfigurations } from 'domains/connect/components/utils/callbackConfigurations.hooks'
import { ConfigurationLoadingWrapper } from 'domains/connect/components/ConfigurationLoadingWrapper'

export const ConnectConfiguration: FunctionComponent = () => {
  const { callbackConfigurations, loading, error } = useCallbackConfigurations()
  return (
    <Fragment>
      <AppHeader title={<FormattedMessage id="connect.configuration.header" />} />
      <ConfigurationLoadingWrapper loading={loading} error={error}>
        <CallbackConfigurationFormContainer
          callbackConfigurations={callbackConfigurations}
        ></CallbackConfigurationFormContainer>
      </ConfigurationLoadingWrapper>
    </Fragment>
  )
}
